import { axiosInstance } from "../lib/axios";
import { HeaderKeys } from "../lib/constants";
import {
  SubmitSurveyRequest,
  SubmitSurveyResponse,
} from "../types/api/customer-survey.types";

const BASE_URL = "/survey";

export async function submitSurvey({
  apiKey,
  orgId,
  projectId,
  conversationId,
  csatRating,
  npsVoting,
  additionalFeedback,
  usedFor,
  liveAgentId,
  liveAgentName,
}: SubmitSurveyRequest) {
  const response = await axiosInstance.post<SubmitSurveyResponse>(
    `${BASE_URL}/${projectId}/submit/${conversationId}`,
    {
      csat_rating: csatRating,
      nps_rating: npsVoting,
      additional_feedback: additionalFeedback,
      usedFor,
      liveAgentId,
      liveAgentName,
    },
    {
      headers: {
        [HeaderKeys.apiKey]: apiKey,
        [HeaderKeys.organizationId]: orgId,
      },
    },
  );
  return response.data;
}
